import React, { Fragment } from 'react';
import { connect, useDispatch } from 'react-redux';
// import {
//   setCategory,
//   saveCategoryRequest,
//   setToast,
//   setCtlgIdEdit,
// } from '../../../../containers/client/actions';
import { saveState } from '../../../../lib/storages';
import {
  // BsTrash,
  // BsThreeDots,
  BsChevronDoubleUp,
  BsChevronUp,
  BsChevronDoubleDown,
} from 'react-icons/bs';
import * as _ from 'lodash';
import {
  makeGetToken,
  makeGetCategory,
  makeGetTypeIndex,
} from '../../../../lib/selector';
// import { v4 as uuidv4 } from 'uuid';
import { translate } from 'react-i18next';

import {
  setTypeIndex,
  setSetting,
} from '../../../../containers/client/actions';

function NavItemRight(props) {
  const dispatch = useDispatch();

  const { token, category, categoryId, t, typeIndex } = props;

  // const _handleDelCategory = () => {
  //   let _category = [...category];
  //   if (
  //     _.some(_category, (o) => o.id === categoryId) &&
  //     categoryId !== 'mac-dinh'
  //   ) {
  //     const _categoryRemove = _.remove(_category, (o) => o.id === categoryId);
  //     // save
  //     dispatch(setCategory(_category));
  //     saveState('category', _category);
  //     if (_categoryRemove) _handleSaveCategory(_categoryRemove[0]);
  //   } else {
  //     const toastMsg = {
  //       id: Math.random(),
  //       msg: t('txt-valid-not-del') + categoryId,
  //       title: t('txt-notice'),
  //     };
  //     dispatch(setToast(toastMsg));
  //   }
  // };

  // const _handleEditCategory = () => {
  //   let _category = [...category];
  //   if (
  //     !_.some(_category, (o) => o.id === categoryId) &&
  //     categoryId !== 'mac-dinh'
  //   ) {
  //     const toastMsg = {
  //       id: Math.random(),
  //       msg: t('txt-valid-not-edit') + categoryId,
  //       title: t('txt-notice'),
  //     };
  //     dispatch(setToast(toastMsg));
  //   } else {
  //     // dispatch edit danh muc categoryId
  //     dispatch(setCtlgIdEdit(categoryId));
  //   }
  // };

  // const _handleSaveCategory = (_newCategory) => {
  //   if (!token) return;

  //   const uuid = uuidv4();
  //   const resData = {
  //     group: 'BACK',
  //     user: token.user,
  //     session: token.session,
  //     cmd: 'DEL_WAT',
  //     rqId: uuid,
  //     channel: 'WTS',
  //     data: _newCategory,
  //   };

  //   dispatch(saveCategoryRequest(resData));
  // };

  const _handleSetTypeIndex = () => {
    const { setTypeIndex, setting } = props;
    const _typeIndex = typeIndex === 1 ? 2 : 
                        typeIndex === 2 ? 3 : 1;
    setTypeIndex(_typeIndex);

    saveState('setting', { ...setting, typeIndex: _typeIndex });
  };

  return (
    <Fragment>
      {/* <div
        onClick={() => _handleDelCategory()}
        className="text-center mr-2 cursor-pointer"
        style={{
          width: '53px',
          height: '26px',
          borderRadius: '13px',
          backgroundColor: '#3a3a3a',
        }}
      >
        <BsTrash className="txt-content" />
      </div>
      <div
        onClick={() => _handleEditCategory()}
        className="text-center mr-2 cursor-pointer"
        style={{
          width: '53px',
          height: '26px',
          borderRadius: '13px',
          backgroundColor: '#3a3a3a',
        }}
      >
        <BsThreeDots className="txt-content" />
      </div> */}
      <div
        onClick={() => _handleSetTypeIndex()}
        className="text-center mr-2 cursor-pointer nav-link"
        style={{width: '50px',}}
      >
      {
        typeIndex === 1 ? <BsChevronDoubleUp className="txt-content" /> :
        typeIndex === 2 ? <BsChevronUp className="txt-content" /> :
        <BsChevronDoubleDown className="txt-content" />
      } 
      </div>
    </Fragment>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getCategory = makeGetCategory();
  const getTypeIndex = makeGetTypeIndex();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      category: getCategory(state),
      typeIndex: getTypeIndex(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, {
  setTypeIndex,
  setSetting,
})(translate('translations')(NavItemRight));
